import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconDesignSystem12 from './IconDesignSystem12';
import IconDesignSystem16 from './IconDesignSystem16';
import IconDesignSystem20 from './IconDesignSystem20';
import IconDesignSystem24 from './IconDesignSystem24';
import IconDesignSystem32 from './IconDesignSystem32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconDesignSystem = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconDesignSystem12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconDesignSystem16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconDesignSystem20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconDesignSystem24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconDesignSystem32 {...props} />}
        </span>
    );
};
IconDesignSystem.displayName = 'FondueIconDesignSystem';

export default memo(IconDesignSystem);
